<div class="fit-content flex">
  <textarea
    [rows]="rows"
    [cols]="cols"
    pInputTextarea
    [value]="value"
    [formControl]="control"
    placeholder="{{ placeholder }}"
    class="flex-grow"
    style="width: 100%"
  ></textarea>
</div>
